import Label from '../UI/Form/Label/Label';
import FormulaBuilderFeedback from './FormulaBuilderFeedback';

type RowPreview = { header: string; value: string };

type FormulaPreviewProps = {
  preview: RowPreview[][];
  showFormulaBuilderFeedback: boolean;
  setShowFormulaBuilderFeedback: (v: boolean) => boolean;
  aiFormulaQuery: boolean;
  aiFormulaResponse: string;
};

const FormulaPreviewContainer = ({
  preview,
  showFormulaBuilderFeedback,
  setShowFormulaBuilderFeedback,
  aiFormulaQuery,
  aiFormulaResponse,
}: FormulaPreviewProps) => {
  return (
    <>
      <div className='mt-1 mb-2'>
        <Label
          dataCy={'formula-preview-label'}
          text={'Sample Result'}
          className={'leading-none mb-2'}
        />
        <ul className='rounded border bg-ui-secondary p-2 text-ui-secondary'>
          {preview.map((el, i) => (
            <li key={i} className='truncate w-full'>
              {el?.[0]?.value?.toString() || ''}
            </li>
          ))}
        </ul>
      </div>
      {showFormulaBuilderFeedback && (
        <FormulaBuilderFeedback
          preview={preview}
          setShowFormulaBuilderFeedback={setShowFormulaBuilderFeedback}
          aiFormulaQuery={aiFormulaQuery}
          aiFormulaResponse={aiFormulaResponse}
        />
      )}
    </>
  );
};

export default FormulaPreviewContainer;
